import { render, staticRenderFns } from "./returnPermissions.vue?vue&type=template&id=33122861"
import script from "./returnPermissions.vue?vue&type=script&lang=js"
export * from "./returnPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports